export const ITEM_CLICK = "slhuinav:item-click";
